import { useState } from "react";
import { connect, useDispatch } from 'react-redux'
import { RootState } from "app/store";
import { updateTeam } from "app/store/slices/editableTournament";
import { TPlayer } from "pages/PlayersPage/types";
import { TMatch } from "pages/TournamentsPage/types";
import { DataGrid } from "../../data-grid";
import { EAlign, EColumnType, TColumns } from "../../data-grid/types";

const cols: TColumns[] = [
    {
      field: 'id',
      headerName: '',
      width: '30px',
      editable: false,
      align: EAlign.left,
      type: EColumnType.string
    },
    {
      field: 'country',
      headerName: 'Страна',
      width: '30px',
      editable: false,
      align: EAlign.left,
      type: EColumnType.flag
    },
    {
      field: 'name',
      headerName: 'Имя игрока',
      width: '300px',
      editable: false,
      align: EAlign.left,
      type: EColumnType.string
    }
  ]

type TPlayerListArgs = {
    players: TPlayer[],
    tours: TMatch[][] | undefined,
    selectedTourId: number | undefined,
    selectedCardId: number | undefined,
    selectedTeamId: number | undefined,
}

const mapStateToProps = (state: RootState) => ({
    players: state.editableTournamentSlice.internalPlayers,
    tours: state.editableTournamentSlice.tours,
    selectedTourId: state.editableTournamentSlice.selectableParameters.tourId,
    selectedCardId: state.editableTournamentSlice.selectableParameters.cardId,
    selectedTeamId: state.editableTournamentSlice.selectableParameters.teamId,
})

export const PlayersList = connect(mapStateToProps)(({
    players,
    tours,
    selectedTourId,
    selectedCardId,
    selectedTeamId,
}: TPlayerListArgs) => {
    const [rows, setRows] = useState<any>([])
    const dispatch = useDispatch()

    const appendPlayerToMatch = (playerId: string) => {
        console.debug('playerId: ', playerId)
        const choosenPlayerId = players.findIndex((p: TPlayer) => ((p._id !== undefined && playerId === p._id) || (p.id !== undefined && playerId === p.id)))
        const targetPlayer = players[choosenPlayerId]

        /**
         * Проверяем что индексы выделения вообще существуют
         */

        if(selectedTourId === undefined || selectedCardId === undefined || selectedTeamId === undefined){
            return
        }

        /**
         * Проверяем что и правда выбрана хоть какая-то карточка
         */
        if(selectedTourId === -1 || selectedTeamId === -1){
            return
        }

        if (selectedTeamId !== 0 && selectedTeamId !== 1) {
            return
        }

        /**
         * Проверяем что вообще существует турнир
         */
        if(!tours){
            return
        }

        dispatch(updateTeam({
            player: targetPlayer,
            teamId: selectedTeamId,
        }))
    }

    if(players.length === 0){
        return <div>Список свободных игроков турнира пуст</div>
    }

    const nextRows = async (page: number, perPageCount: number) => {
        const newPlayers = players.slice(page * perPageCount, (page * perPageCount) + perPageCount)
        setRows(newPlayers)
        return newPlayers
    }

    return <DataGrid
        nextRows={nextRows}
        count={players.map((p: TPlayer) => ({...p, id: p.id || p._id})).length}
        rows={rows}
        columns={cols}
        controls={true}
        onRowDblClick={appendPlayerToMatch}
    />
})
